import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const API = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 403 && err.response?.data?.detail === 'CGV_OUTDATED') {
      window.dispatchEvent(new CustomEvent('cgv-outdated'));
    }
    return Promise.reject(err);
  },
);

export default API;
